import { startSession } from './lib/bootstrapSession';
import { StrictMode, useEffect } from 'react';
import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

/** Identical tree for the live app and optional public HTML snapshots (Appendix A.7). */
export function Root({ client }: { client: QueryClient }): JSX.Element {
  useEffect(() => {
    void startSession();
  }, []);
  return (
    <StrictMode>
      <QueryClientProvider client={client}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </StrictMode>
  );
}
